"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JUSTIFICATION = void 0;
var JUSTIFICATION;
(function (JUSTIFICATION) {
    JUSTIFICATION["TOP_LEFT"] = "TL";
    JUSTIFICATION["TOP_CENTER"] = "TC";
    JUSTIFICATION["TOP_RIGHT"] = "TR";
    JUSTIFICATION["MIDDLE_LEFT"] = "ML";
    JUSTIFICATION["MIDDLE_CENTER"] = "MC";
    JUSTIFICATION["MIDDLE_RIGHT"] = "MR";
    JUSTIFICATION["BOTTOM_LEFT"] = "BL";
    JUSTIFICATION["BOTTOM_CENTER"] = "BC";
    JUSTIFICATION["BOTTOM_RIGHT"] = "BR";
})(JUSTIFICATION = exports.JUSTIFICATION || (exports.JUSTIFICATION = {}));
//# sourceMappingURL=interfaces.js.map